import type { FC } from 'react';

const WidgetLoader: FC = () => <div data-testid="widget-loader" />;

WidgetLoader.displayName = 'WidgetLoader';

export default WidgetLoader;
